import i18n from '@/plugins/i18n';
import { notify, useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { NotifyPresets } from './notifyPresets.types';

export const notifyPresets = {
  mixins: [notify],
  computed: {
    // eslint-disable-next-line no-unused-vars
    notifyPresets(): NotifyPresets {
      return {
        requestSentSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.requestSent.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        operationFailed: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.requestSent.error'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentsActionSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.postActionDialogText.toast.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentSingeActionFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.postActionDialogText.toast.error'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentBuildPrioritySuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.priorityText.success', ['Build']), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentBuildPriorityFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.priorityText.buildPriorityFail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentLogLevelSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.logLevel.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentLogLevelFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.logLevel.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentClearCacheSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.clearCache.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentClearCacheFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.clearCache.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentBuildAvoidanceSuccess: (value, effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.buildAvoidance.success', [value]), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentBuildAvoidanceFail: value => {
          (this as any).toastMessage(i18n.global.t('agentsTable.buildAvoidance.fail', [value]), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentSetAllowHelperEnabledSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.setAllowHelperEnabled.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentSetAllowHelperEnabledFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.setAllowHelperEnabled.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentSetHelperEnabledSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.setHelperEnabled.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentSetHelperEnabledFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.setHelperEnabled.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentAssignmentPrioritySuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.priorityText.success', ['Assignment']), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentAssignmentPriorityFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.priorityText.assignmentPriorityFail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentSingleLicenseConfigUpdate: (messageType, message) => {
          (this as any).toastMessage(i18n.global.t(`agentsTable.licenseConfig.toast.${messageType}.${message}`), messageType);
        },
        agentResizeCacheSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.resizeCache.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentResizeCacheFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.resizeCache.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
        agentSetAgentDescriptionSuccess: (effectedAgentsNumber?) => {
          (this as any).toastMessage(i18n.global.t('agentsTable.agentDescription.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
        },
        agentSetAgentDescriptionFail: () => {
          (this as any).toastMessage(i18n.global.t('agentsTable.agentDescription.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
        },
      };
    },
  },
};

export const useNotifyPresets = () => {
  const { toastMessage } = useNotify();
  const { t } = useI18n();

  // eslint-disable-next-line no-unused-vars
  const presets: NotifyPresets = {
    requestSentSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.requestSent.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    operationFailed: () => {
      toastMessage(t('agentsTable.requestSent.error'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentsActionSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.postActionDialogText.toast.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentSingeActionFail: () => {
      toastMessage(t('agentsTable.postActionDialogText.toast.error'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentBuildPrioritySuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.priorityText.success', ['Build']), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentBuildPriorityFail: () => {
      toastMessage(t('agentsTable.priorityText.buildPriorityFail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentLogLevelSuccess: (effectedAgentsNumber?) => {
      toastMessage(t(`agentsTable.logLevel.success`), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentLogLevelFail: () => {
      toastMessage(t('agentsTable.logLevel.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentClearCacheSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.clearCache.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentClearCacheFail: () => {
      toastMessage(t('agentsTable.clearCache.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentBuildAvoidanceSuccess: (value, effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.buildAvoidance.success', [value]), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentBuildAvoidanceFail: value => {
      toastMessage(t('agentsTable.buildAvoidance.fail', [value]), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentSetAllowHelperEnabledSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.setAllowHelperEnabled.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentSetAllowHelperEnabledFail: () => {
      toastMessage(t('agentsTable.setAllowHelperEnabled.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentSetHelperEnabledSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.setHelperEnabled.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentSetHelperEnabledFail: () => {
      toastMessage(t('agentsTable.setHelperEnabled.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentAssignmentPrioritySuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.priorityText.success', ['Assignment']), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentAssignmentPriorityFail: () => {
      toastMessage(t('agentsTable.priorityText.assignmentPriorityFail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentSingleLicenseConfigUpdate: (messageType, message) => {
      toastMessage(t(`agentsTable.licenseConfig.toast.${messageType}.${message}`), messageType);
    },
    agentResizeCacheSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.resizeCache.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentResizeCacheFail: () => {
      toastMessage(t('agentsTable.resizeCache.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
    agentSetAgentDescriptionSuccess: (effectedAgentsNumber?) => {
      toastMessage(t('agentsTable.agentDescription.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS, { effectedAgentsNumber: effectedAgentsNumber || null });
    },
    agentSetAgentDescriptionFail: () => {
      toastMessage(t('agentsTable.agentDescription.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    },
  };
  return { notifyPresets: presets };
};
